module.exports = __webpack_public_path__ + "05a8d23a0478de9e1f3ab7694f51ce89.png";